import { handleAPIError } from "@services/Base";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { CLIENT_API_URL } from "../../../config";
import { Client, ClientCreate } from "../types";

export const useSaveClient = () => {
  return useMutation({
    mutationFn: (props: ClientCreate) =>
      axios
        .post(
          `${CLIENT_API_URL}/waves-client-manager-api/v1/clients/`,
          props,
          {}
        )
        .then((response) => {
          return response.data as Client;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
